import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import CoolingTowerDetail from '../../components/ac_central/CoolingTowerDetail';
import { defaultRejectHandler } from '../../utils/utility';
import { createCoolingTower } from '../../redux/ac_central/cooling_tower_actions';

class CoolingTowerCreateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.ctDetail = undefined;
  }

  onSaveHandler() {
    const newCoolingTower = this.ctDetail.getWrappedInstance().getWrappedInstance().getCTData();
    this.props.createCoolingTower(newCoolingTower);
  }

  render() {
    const { isCreating, errorMessage, ctDetail, t, createCoolingTower, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('create cooling tower')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CoolingTowerDetail
            ct={ctDetail}
            ref={ref => (this.ctDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="air-conditioning-cooling-tower-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {isCreating ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  errorMessage: state.ac.coolingTower.errorMessage,
  isCreating: state.ac.coolingTower.isCreating,
});

const mapDispatchToProps = dispatch => ({
  createCoolingTower: ct => defaultRejectHandler(dispatch(createCoolingTower(ct.name, 0, 'TR', ct.power_required, ct.description, ct.image))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(CoolingTowerCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/ac_central/CoolingTowerCreateModal.js